import {
  BusinessType,
  RightRankType,
  UserDataRankType,
  CompanyType,
  CustomerGroupType,
  SupplyType,
} from './types';

export const BusinessTypeMap = {
  [BusinessType.group]: '饭圈',
  [BusinessType.packed]: '包餐企业',
  [BusinessType.unpacked]: '非包餐企业',
  [BusinessType.other]: '其他',
};

export const RiceCircleTypeMap = {
  [CustomerGroupType.other]: '未认证到饭圈用户',
  [CustomerGroupType.group]: '饭圈用户',
};

export const CompanyTypeMap = {
  [CompanyType.other]: '未认证企业用户',
  [CompanyType.packed]: '包餐企业',
  [CompanyType.unpacked]: '非包餐企业',
  [CompanyType.samepacked]: '包餐+非包餐企业',
};

export const BusinessTypeChartMap = {
  [BusinessType.group]: '饭圈',
  [BusinessType.packed]: '包餐',
  [BusinessType.unpacked]: '非包餐',
  [BusinessType.other]: '其他',
};

export const RightRankTypeMap = {
  [RightRankType.bigRegionList]: '大区排名',
  [RightRankType.cityList]: '城市排名',
  [RightRankType.businessDistrictList]: '商圈排名',
  [RightRankType.companyList]: '企业订单排名',
  [RightRankType.shopList]: '门店订单排名',
};

export const OnlyRightRankTypeMap = {
  [RightRankType.bigRegionList]: '大区',
  [RightRankType.cityList]: '城市',
  [RightRankType.businessDistrictList]: '商圈',
  [RightRankType.companyList]: '企业订单',
  [RightRankType.shopList]: '门店订单',
};

export const UserRankTypeMap = {
  [UserDataRankType.firm]: '企业认证用户排名',
  [UserDataRankType.fandom]: '饭圈用户排名',
};

export const MoreRankType = {
  bigRegionList: 'bigregion',
  cityList: 'city',
  businessDistrictList: 'businessgroup',
  companyList: 'enterprise',
  shopList: 'store',
};

export const DataDimension = [
  'GMV',
  '订单数',
  '补贴率',
  'UV转化率',
  '订单超时率',
  '访问认证用户数',
];

export const initAreaOption = {
  id: '',
  pId: 0,
  value: '',
  title: '全国',
  isLeaf: true,
  level: -1,
};
export const initAreaOptionPower = {
  id: '',
  pId: 0,
  value: '',
  title: '全部',
  isLeaf: true,
  level: -1,
};

export const initDistrictOption = {
  label: '全部',
  value: '',
};

export const initBusinessTypeOption = {
  label: '全部',
  value: '',
  key: '',
};
export const SupplyTypeMap = {
  [SupplyType.supply]: '补单订单',
  [SupplyType.unsupply]: '普通订单',
};

/** 筛选条件：业务方向 */
export const BUSINESS_DIRECTION_MAP = {
  0: '签约',
  1: '非签约',
  2: '食堂项目',
  '-9999': '其他',
};

export const MEAL_SECTION_MAP = {
  1: '早餐',
  2: '午餐',
  3: '下午茶',
  4: '晚餐',
  5: '夜宵',
};

export const ORDER_TYPE_MAP = {
  0: '外卖',
  1: '自提',
  2: '堂食',
  4: '卡券',
  '5,6': '福利商城',
  '-9999': '其他',
};

/** 渠道 */
export const CHANNEL_CN_MAP = {
  0: '外卖/自提',
  1: '堂食',
  2: '卡劵',
  3: '福利商城',
  '-9999': '其他',
};
